import React from 'react';

/** Compact Do Not Contact / compliance badge — use next to names or in status columns. */
export const DncBadge: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center rounded-md border border-amber-500/50 bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-950 dark:bg-amber-950/50 dark:text-amber-100 dark:border-amber-400/40 ${className}`}
    title="Do Not Contact — outbound email is suppressed"
  >
    DNC
  </span>
);

export function dncRowClassName(dnc?: boolean): string | undefined {
  if (!dnc) return undefined;
  return 'bg-amber-50/80 dark:bg-amber-950/20';
}
